import { CourseStatusAttemptEnum } from '@/client/courses';
import { LearnerDashboardPage } from '@/pages/dashboards/learner/courses/LearnerDashboardPage';
import React from 'react';

export const LearnerDashboardCompletedPage: React.FC = () => {
  return <LearnerDashboardPage type={CourseStatusAttemptEnum.COMPLETED} />;
};
